/**
 * Interface for the parsed query parameters from the Academy MFE URL.
 * Maps the URL query parameters to the internal training parameter structure.
 */
export interface AcademyQueryParams {
	trainingId: string;
	trainingVersion: string;
}

/**
 * Parses Academy training parameters from a query string.
 *
 * @param queryString - The query string to parse (e.g., "courseId=scorm&courseVersion=1.0.0")
 * @returns AcademyQueryParams object with parsed training parameters
 *
 * @example
 * ```typescript
 * const params = parseTrainingParams("courseId=scorm&courseVersion=1.0.0");
 * // Returns: { trainingId: "scorm", trainingVersion: "1.0.0" }
 * ```
 */
export function parseTrainingParams(queryString: string): AcademyQueryParams {
	const params = new URLSearchParams(queryString);
	const parsedParams: AcademyQueryParams = {
		trainingId: params.get("courseId") || "",
		trainingVersion: params.get("courseVersion") || "",
	};
	return parsedParams;
}
